import { camelizeKeys } from '~/redux/api/transformers/utils';
import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

import { DataWrapper } from '../../ApiTypes';
import { CreateGroupPayload, GroupServer } from './types';

export const createGroup = async (
  group: CreateGroupPayload,
  options: ServiceRequestConfig = {},
) => {
  const response = await managedEntities.post<DataWrapper<GroupServer>>(
    '/groups',
    group,
    { showErrorToast: true, ...options },
  );
  return camelizeKeys(response.data);
};
